import { Box } from '@mui/material';
import styled from 'styled-components';
import { COLORS, SHADOWS } from './constants';

export const TableBox = styled(Box)`
  width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
`;

export const TableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
`;

export const FixedFiltersContainer = styled.div`
  background: ${COLORS.white};
  border-radius: 5px 5px 0 0;
  box-shadow: ${SHADOWS.table};
  border: 1px solid ${COLORS.borderGray};
`;

export const FixedPaginationContainer = styled.div`
  background: ${COLORS.white};
  padding: 3px;
  border: 1px solid ${COLORS.borderGray};
  border-top: none;
  border-bottom: 1px solid ${COLORS.borderGray};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ScrollableContent = styled.div`
  overflow-x: auto;
  overflow-y: auto;
  width: 100%;
  flex: 1;
  min-height: 0;
  border: 1px solid ${COLORS.borderGray};
  border-top: none;
  border-radius: 0 0 5px 5px;

  &::-webkit-scrollbar-track {
    background: ${COLORS.primary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.primary};
  }

  scrollbar-width: auto;
  scrollbar-color: ${COLORS.primary} ${COLORS.white};
`;
